import { Field } from "formik";
import React, { useEffect } from "react";
import { useState } from "react";
import {
  FieldInput,
  FieldDropSide,
  SearchableList,
  FieldInputSSN,
  FieldInputDecimal,
  FieldButtonGroup,
  FieldInputNumber,
} from "../../../components";
import {
  getFormattedSsn,
  required,
  OPTIONS_DATA_MAPPER,
  toOptionValuesFromMapper,
  yesNoOptions,
} from "../../../utils";
import company from "../../../mocks/company.json";
import { useRequest, useDeepEffect } from "../../../abstracts";
import { getCompaniesList, getPayrollFrequencies } from "../../../services";
import { number } from "prop-types";

const BankAccountDetailsFields = (props) => {
  const { fields, values, setFieldValue, isEdit, isSave, handleChange } = props;
  const BankAccountTypeOptions = [
    {
      label: "Savings",
      value: 1,
    },
    {
      label: "Checking",
      value: 2,
    },
  ];
  return (
    <div>
      <p className="mt-20 plan-sub-heading">Bank Information</p>
      <Field
        size="md"
        isRequired
        name={fields.bankAccountNumber}
        label={"Bank account Number"}
        type="text"
        autoComplete="off"
        //value={getFormattedSsn(values[fields.bankAccountNumber])}
        value={values[fields.bankAccountNumber]}
        onChange={handleChange}
        disabled={isEdit && !isSave}
        component={FieldInputNumber}
        maxLength="18"
      />
      <Field
        size="md"
        isRequired
        name={fields.accountHolderName}
        value={values[fields.accountHolderName]}
        label="Account Holder Name"
        type="text"
        disabled={isEdit && !isSave}
        component={FieldInput}
      />
      <Field
        size="md"
        isRequired
        name={fields.bankAccountName}
        value={values[fields.bankAccountName]}
        label="Bank Name"
        disabled={isEdit && !isSave}
        onChange={handleChange}
        component={FieldInput}
      />
      <Field
        size="md"
        isRequired
        name={fields.routingNumber}
        label={"Routing number"}
        type="text"
        autoComplete="off"
        value={values[fields.routingNumber]}
        onChange={handleChange}
        disabled={isEdit && !isSave}
        component={FieldInputNumber}
      />
      <Field
        isRequired
        name={fields.bankAccountType}
        label={"Type of account"}
        options={BankAccountTypeOptions}
        selectedValue={values[fields.bankAccountType]}
        onChange={(value) => {
          setFieldValue(fields.bankAccountType, value);
        }}
        disabled={isEdit && !isSave}
        component={FieldButtonGroup}
        size="md"
      />
    </div>
  );
};

export default BankAccountDetailsFields;
